// Plan year handling for ID cards. A staggered employer has a different current plan year per plan type
// (MEDICAL on a January plan year, DENTAL on a July renewal), so each card carries its own plan year id.

// The plan year a card shows its dates from: its own when loaded, else the guide's (the single-year case).
export const getCardPlanYear = (
  planYearsById: Record<string, any> | undefined,
  cardPlanYearId: string | undefined,
  fallback: any
): any => (cardPlanYearId && planYearsById?.[cardPlanYearId]) || fallback;

// The election one card shows. With one row for the benefit this is that row. With more than one (an old plan
// year's row next to the renewed one) the row of the plan year that starts latest wins; rows whose plan year is
// not known keep their order, so the first one is picked as before.
export const pickCardElection = (
  elections: any[] | undefined | null,
  benefitKind: string,
  individualId: string,
  planYearsById: Record<string, any> | undefined
) => {
  const matches = (elections || []).filter(
    (item: any) =>
      item?.benefitKind === benefitKind && item.individualId === individualId
  );
  const startOf = (row: any): string =>
    planYearsById?.[row?.planYearId]?.startDate || '';
  return matches.reduce(
    (best: any, row: any) => (startOf(row) > startOf(best) ? row : best),
    matches[0]
  );
};
